import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { SearchIcon, Star } from "lucide-react";
import FeatureHeader from "../components/FeatureHeader";

const AllProviders = () => {
  const [pharmacies, setPharmacies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPharmacies, setFilteredPharmacies] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/api/providers")
      .then(res => {
        setPharmacies(res.data.providers);
        setFilteredPharmacies(res.data.providers);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    setFilteredPharmacies(
      pharmacies.filter(p =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, pharmacies]);

  const handleMouseEnter = useCallback((e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.35)";
  }, []);

  const handleMouseLeave = useCallback((e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.2)";
  }, []);

  return (
    <div style={styles.page}>
      
      {/* Header */}
      <FeatureHeader
        title="All Lab Providers"
        subtitle="Book lab test from home and get result fast"
        onBack={() => navigate(-1)}
        />

      {/* Search */}
      <div style={styles.searchWrapper}>
        <SearchIcon size={18} color="#888" />
        <input
          placeholder="Search labs"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
      </div>

      {/* Providers */}
      <div style={styles.list}>
        {filteredPharmacies.map(pharmacy => (
          <div
            key={pharmacy._id}
            style={styles.card}
            onClick={() => navigate(`/providers/${pharmacy._id}`)}
          >
            <img
              src={pharmacy.logo || "https://via.placeholder.com/64"}
              alt={pharmacy.name}
              style={styles.logo}
            />

            <div style={{ flex: 1 }}>
              <div style={styles.name}>{pharmacy.name}</div>

              <div style={styles.address}>
                {pharmacy.city}
              </div>

              <div style={styles.metaRow}>
                <Star size={12} fill="#FFC107" color="#FFC107" />
                <span style={styles.metaText}>
                  {pharmacy.rating || "4.5"} ({pharmacy.reviews || 120})
                </span>

                {pharmacy.deliveryAvailable && (
                  <span style={styles.delivery}>• Home sample</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredPharmacies.length === 0 && (
        <p style={styles.empty}>No providers found</p>
      )}
    </div>
  );
};

export default AllProviders;

const styles = {
  page: {
    padding: 16,
    maxWidth: 480,
    margin: "0 auto",
    backgroundColor: "#F8F8FB",
    minHeight: "100vh",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 16,
  },

  backArrow: {
    cursor: "pointer",
    fontSize: "20px",
    background: "rgba(255,255,255,0.2)",
    padding: "8px 10px",
    borderRadius: "50%",
    transition: "background 0.2s ease",
  },

  headerTitle: {
    fontSize: 18,
    fontWeight: 700,
  },

  searchWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    backgroundColor: "#fff",
    borderRadius: 14,
    padding: "12px 14px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    marginBottom: 20,
  },

  searchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    fontSize: 14,
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  card: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 12,
    display: "flex",
    gap: 12,
    alignItems: "center",
    boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
    cursor: "pointer",
  },

  logo: {
    width: 64,
    height: 64,
    borderRadius: 14,
    objectFit: "cover",
  },

  name: {
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 4,
  },

  address: {
    fontSize: 12,
    color: "#777",
    marginBottom: 4,
  },

  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#555",
  },

  metaText: {
    fontWeight: 600,
  },

  delivery: {
    color: "#6A3AFF",
    fontWeight: 600,
  },

  empty: {
    textAlign: "center",
    marginTop: 40,
    color: "#888",
  },
};
